module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('strong', [_c('span', {
    staticClass: "underline"
  }, [_vm._v("LARRY BOND")])])]), _vm._v(" "), _c('h1', {
    staticClass: "book-title"
  }, [_vm._v("COLD CHOICES")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "45%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right-para"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/publisher.jpg"
    }
  })])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_c('strong', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A TOM DOHERTY ASSOCIATES BOOK"), _c('br'), _vm._v("NEW YORK")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73736436","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/title.vue
// module id = 66
// module chunks = 0